module.exports = __webpack_public_path__ + "static/media/Logo_izzi.6380a28b.png";